<template>
  <a-modal
    :visible="visible"
    @cancel="
      () => {
        visible = false
      }
    "
    @ok="nameEdit"
    width="740px"
    title="修改产品名称"
    :getContainer="() => document.getElementById('app')"
    wrapClassName="imgModal"
  >
    <a-form :form="form" :label-col="{ span: 6 }" :colon="false" :wrapper-col="{ span: 17 }">
      <div class="filWrap">
        <span
          ><span style="color: #333">语言筛选:</span
          ><a-dropdown :trigger="['click']">
            <a class="dropdown-a" @click="e => e.preventDefault()">
              {{ languageData[language] }} <a-icon class="down-icon" type="down" />
            </a>
            <a-menu slot="overlay">
              <a-menu-item :key="index" v-for="(item, index) in languageData" @click="language = index">
                {{ item }}
              </a-menu-item>
            </a-menu>
          </a-dropdown></span
        >
      </div>
      <a-form-item>
        <template slot="label">
          <span style="vertical-align: top;">{{ languageData[language] }}名称</span>
        </template>
        <template v-for="(lIt, li) in languageData">
          <a-input
            :key="li"
            :maxLength="200"
            v-if="+li === +language && product.product_name_alias"
            allowClear
            placeholder="请输入产品名称"
            v-model="product.product_name_alias[language]"
          ></a-input>
        </template>
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script>
import { modifyNames } from '@/api/productLibrary/index'
import { languageData, languageKey } from '@/utils/const'
export default {
  name: 'ImageSelect',
  data() {
    return {
      visible: false,
      languageData: languageData,
      languageKey: languageKey,
      language: 1,
      product: {},
      form: this.$form.createForm(this, { name: 'nameEdit' })
    }
  },
  components: {},
  props: [],
  created() {},
  methods: {
    nameEdit() {
      this.form.validateFields((err, value) => {
        console.log('value===', value)
        if (!err) {
          const obj = {
            ids: this.product.id
          }
          this.languageKey.forEach((it, i) => {
            obj[it] = this.product.product_name_alias[i]
          })
          modifyNames(obj).then(res => {
            console.log('res===', res)
            this.visible = false
          })
        }
      })
    }
  },
  mounted() {},
  watch: {},
  computed: {}
}
</script>

<style scoped lang="less">
.filWrap {
  padding: 0 30px;
  margin-bottom: 10px;
  text-align: right;
}
</style>
